module.exports = __webpack_public_path__ + "static/img/in_dev.1cdb1ad5.png";